export const prettyJSONStr = (str) => {
  try {
    return JSON.stringify(JSON.parse(str), null, '\t');
  } catch {
    return '';
  }
};

export const packJSONObjToStr = (obj) => {
  try {
    return JSON.stringify(obj, null, '\t');
  } catch {
    return '';
  }
};
